module.exports = __webpack_public_path__ + "img/1001.d02d24f1.png";